import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import { FormInput } from "../../shared/formElements/formInput/FormInput";
import { FormImagePreviewAndUpload } from "../../shared/formElements/FormImagePreviewAndUpload/FormImagePreviewAndUpload";

import {
  moduleArray,
  pageArray,
} from "../../../pages/advertisement/advertisementFilter/AdvertisementFilterPage";

import { FormCheckboxChips } from "../../shared/formElements/formCheckBoxChip/FormCheckBoxChip";
import { FormDropdown } from "../../shared/formElements/formDropdown/FormDropdown";

import classes from "./advertisementDetailForm.module.css";

export const AdvertisementDetailForm = ({
  initialValues,
  onSubmit,
  onDelete,
  isSubmitting,
  isDeleting,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { isValid, errors },
  } = useForm({
    defaultValues: initialValues,
    mode: "onChange",
  });

  useEffect(() => {
    reset(initialValues);
  }, [initialValues, reset]);

  const smallScreenUrl = watch("url");
  const largeScreenUrl = watch("url_2");

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      {/* -------------------- BASIC INFO -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Advertisement Information</h3>

        <div className={classes.grid}>
          <FormInput id="sequence" label="Sequence" register={register} />
          <FormInput
            id="navigate_to_page"
            label="Navigate To Page"
            register={register}
          />
          <FormInput id="tag" label="Tag" register={register} />
          <FormInput id="params" label="Params" register={register} />

          <FormInput
            id="alt"
            label="Alt Text"
            register={register}
            validation={{ required: "Alt Text is required" }}
            error={errors.alt?.message}
            required
          />

          <FormCheckboxChips
            id="media_type"
            label="Media Type"
            options={[
              { id: "image", label: "Image" },
              { id: "video", label: "Video" },
            ]}
            watch={watch}
            setValue={setValue}
            register={register}
            validation={{ required: "Media type is required" }}
            error={errors.media_type?.message}
          />

          <FormDropdown
            id="category"
            label="Select Module"
            options={moduleArray}
            watch={watch}
            setValue={setValue}
            register={register}
            validation={{ required: "Category is required" }}
            error={errors.category?.message}
            required
          />

          <FormDropdown
            id="page"
            label="Select Page"
            options={pageArray}
            watch={watch}
            setValue={setValue}
            register={register}
            validation={{ required: "Page is required" }}
            error={errors.page?.message}
            required
          />
        </div>
      </div>

      {/* -------------------- IMAGES -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Small Screen Image</h3>

        <FormImagePreviewAndUpload
          id="url"
          url={smallScreenUrl}
          register={register}
          setValue={setValue}
          validation={{ required: "Small screen image is required" }}
          error={errors.url?.message}
          minWidth={640}
          minHeight={310}
        />
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Large Screen Image</h3>

        <FormImagePreviewAndUpload
          id="url_2"
          url={largeScreenUrl}
          register={register}
          setValue={setValue}
          validation={{ required: "Large screen image is required" }}
          error={errors.url_2?.message}
          minWidth={1600}
          minHeight={340}
        />
      </div>

      {/* -------------------- ACTION BUTTONS -------------------- */}
      <div className={classes.actions}>
        <button
          type="button"
          className={classes.deleteBtn}
          onClick={onDelete}
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </button>

        <button
          type="submit"
          className={classes.submitBtn}
          disabled={!isValid || isSubmitting}
        >
          {isSubmitting ? "Updating..." : "Update Advertisement"}
        </button>
      </div>
    </form>
  );
};
